
<div :class="['modal', {'is-visible': visible}]"></div>
